<template>
  <div class="error_view">

    <div class="error-contents">
      <div class="error-image">
        <img src="@/assets/404-not-found.png" alt="not_found">
      </div>
      <div class="title">요청하신 페이지를 찾을 수 없습니다.</div>
      <div class="description">
        <p>방문하시려는 페이지의 주소가 잘못 입력되었거나,<br>
          변경 또는 삭제되어 요청하신 페이지를 찾을 수 없습니다.</p>
        <p>입력하신 페이지의 주소가 정확한지 다시 한 번 확인해 주시기 바랍니다.</p>
      </div>
      <div class="btn-go-home">
        <a class="goHome" href="/">글꼴 프로젝트 홈</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

<style lang="scss" scoped>
.error_view {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .error-contents {
    text-align: center;
    .error-image {
      width: 100px;
      padding: 20px;
      margin: 0 auto;
    }
    .title {
      font-size: 36px;
    }
    .description {
      padding: 30px;
      p {
        margin-bottom: 10px;
      }
    }
    .goHome {
      display: inline-block;
      text-align: center;
      white-space: nowrap;
      vertical-align: middle;
      user-select: none;
      font-size: 16px;
      border: 1px solid transparent;
      transition: background-color .15s ease-in-out;
      outline: none;
      padding: 7px 32px;
      color: #fff;
      background-color: #3090d6;
    }
  }
}
</style>
